import { Injectable } from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {Observable} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LastusedService {
  static lastUsedPath = '/lastused/';
  lastUsed: Observable<any>;

  constructor(private db:AngularFireDatabase, private translate: TranslateService) {
    // cannot be used as this constructor is called before the user is logged in
    // therefore the initLastUsedService method does the job, the constructor normally does
  }

  initLastUsedService(uid: string) {
    const p = LastusedService.lastUsedPath + uid;
    //console.log(`path: ${p}`);
    this.lastUsed = this.db.object( p ).valueChanges();
  }

  getLastUsed(): Observable<string> {
    return this.lastUsed;
  }

}
